/**
 * @package
 * @author Artem Ilinykh devsinglesly@gmail.com
 * @class Provider
 */
import { Resource } from '@/modules/backend/Entities/Resource';
import { Type } from 'class-transformer';

export class Provider {
  private readonly id!: number;

  private readonly name: string;

  @Type(() => Resource)
  private readonly resources: Resource[];

  constructor(name: string, resources: Resource[]) {
    this.name = name;
    this.resources = resources;
  }

  public getId(): number {
    return this.id;
  }

  public getName(): string {
    return this.name;
  }

  public getResources(): Resource[] {
    return this.resources || [];
  }
}
